import { noraWebTheme } from "./noraWebTheme";
import createTheme from "@mui/material/styles/createTheme";

export const ListItemTextStyling = {
  '& .MuiListItemText-primary': {
    fontSize: '1.2rem',
    p:0,
    m:0,
  },
  '& .MuiListItemText-root': {
    p:0,
    m:0,
  },
  '& .MuiListItemText-dense':{
    p:0,
    m:0,
  }
};

export const ListItemStyling = {
  '& .MuiListItem-gutters': {
    p:0,
    m:0,
  },
  '& .MuiListItem-padding':{
    p:0,
    m:0,
  },
  '& .MuiListItem-dense': {
    p:0,
    m:0,
  },
  '& .MuiListItem-root': {
    p:0,
    m:0,
  }
};

export const ListTheme = createTheme(noraWebTheme,{
  components: {
    // Name of the component
    MuiListItemText: {
      styleOverrides: {
        // Name of the slot
        primary: {
          // Some CSS
          [noraWebTheme.breakpoints.down('md')]: {
            fontSize: '1rem',
            fontWeight:'Bold',
            m:0,
            p:0,
          },
          [noraWebTheme.breakpoints.up('md')]: {
            fontSize: '1.2rem',
            fontWeight:'Bold',
          },
        },
        root:{
          m:0,
          p:0,
        },
        dense: {
          m:0,
          p:0,
        }
      },
    },
    MuiListItem:{
      styleOverrides: {
        // Name of the slot
        root: {
            m:0,
            p:0,
        },
        padding: {
          m:0,
          p:0,
        },
        gutters: {
          m:0,
          p:0,
        }
      },
    },
  },
});